<template>
  <v-card>
    <v-card-title>
      {{ title }}
      <v-spacer />
      <v-btn @click="addTrait(categoryId ? categoryId : null)"> Add </v-btn>
    </v-card-title>
    <v-divider />
    <v-data-table
      :loading="loading || savingTrait"
      :headers="trait_headers"
      :items="traits"
      disable-pagination
      hide-default-footer
      disable-sort
      mobile-breakpoint="0"
    >
      <template #[`item.text`]="{ item }">
        <v-text-field
          v-model="item.text"
          outlined
          dense
          maxlength="100"
          hide-details="auto"
          :disabled="!!categoryId && !item.categoryId"
          @input="changed = true"
          @blur="saveTrait(item)"
        />
      </template>
      <template #[`item.sortOrder`]="{ item }">
        <v-text-field
          v-model="item.sortOrder"
          outlined
          dense
          hide-details="auto"
          type="number"
          :disabled="!!categoryId && !item.categoryId"
          @input="changed = true"
          @blur="saveTrait(item)"
        />
      </template>
      <template #[`item.actions`]="{ item }">
        <v-btn
          v-if="!!categoryId && !item.categoryId"
          :to="`/print/materials`"
          small
        >
          Configure
        </v-btn>
        <template v-else>
          <v-btn
            v-if="item.categoryId"
            icon
            title="Convert to Base Trait"
            @click="moveToBaseTrait(item.id)"
          >
            <v-icon>publish</v-icon>
          </v-btn>
          <v-btn
            icon
            title="Delete"
            @click="deleteTrait(item.id)"
          >
            <v-icon>delete</v-icon>
          </v-btn>
        </template>
      </template>
    </v-data-table>
    <MaterialTraitAddDialog ref="addTrait" />
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { orderBy } from 'lodash';
import MaterialTraitAddDialog from '@/components/print/MaterialTraitAddDialog';
export default {
  components: { MaterialTraitAddDialog },
  props: {
    material: { type: Object },
    categoryId: { type: Number },
    title: { type: String, default: 'Traits' },
    isBase: { type: Boolean, default: false }
  },
  data: () => ({
    loading: false,
    savingTrait: false,
    refreshing: false,
    changed: false
  }),
  computed: {
    trait_headers() {
      const list = [
        { text: 'Category', value: 'categoryName' },
        { text: 'Text', value: 'text' },
        { text: 'Sort', value: 'sortOrder' },
        { text: '', value: 'actions' }
      ];
      return list.filter((x) => !x.hide);
    },
    traits() {
      let list = this.material.traits;
      if (this.isBase) {
        list = list.filter((x) => !x.categoryId);
      } else if (this.categoryId) {
        list = list.filter((x) => x.categoryId === this.categoryId || !x.categoryId);
      } else {
        list = list.filter((x) => !!x.categoryId);
      }
      return orderBy(
        list.map((x) =>
          Object.assign(x, {
            categoryName: this.category_name(x.categoryId) || '*** Base ***'
          })
        ),
        ['categoryName', 'sortOrder'],
        ['asc', 'asc']
      );
    },
    ...mapGetters({
      materials: 'print/materials',
      category_name: 'lookup/category_name'
    })
  },
  created() {},
  methods: {
    addTrait(categoryId) {
      this.$refs.addTrait.showDialog(this.material.id, categoryId);
    },
    saveTrait(item) {
      if (!this.changed) {
        return;
      }
      this.savingTrait = true;
      this.$store
        .dispatch('print/saveMaterialTrait', item)
        .then(() => {
          this.$root.$snackbarSuccess('Material trait saved');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.savingTrait = false;
        });
    },
    moveToBaseTrait(id) {
      this.savingTrait = true;
      this.$store
        .dispatch('print/moveToBaseTrait', id)
        .then(() => {
          this.$root.$snackbarSuccess('Material trait moved to Base');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.savingTrait = false;
        });
    },
    deleteTrait(id) {
      this.savingTrait = true;
      this.$store
        .dispatch('print/deleteMaterialTrait', {
          id,
          materialId: this.material.id
        })
        .then(() => {
          this.$root.$snackbarSuccess('Material trait deleted');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.savingTrait = false;
        });
    }
  }
};
</script>
